import React from 'react'
import PageHeader from '../../Components/Instructor_Dashboard/PageHeader'
import '../../App.css'
import {
    Button,
    Form,
    Input,
  } from 'antd';

const ZoomLive_Settings = () => {
    const [form] = Form.useForm();
  const variant = Form.useWatch('variant', form);
  return (
    <div>
       <div>
        <PageHeader title={'Zoom live settingss'}/>
       </div>
 
      
       <div className="zoom_live">

            <div className="zoomlive_left">
              <h6>MEETING SDK CONFIGURATION</h6>
                <Form
                  form={form}
                  variant={variant || 'filled'}
                  layout="vertical" // Use the "vertical" layout to ensure labels are above inputs
                  style={{
                    maxWidth: 600,
                  }}
                  initialValues={{
                    variant: 'filled',
                  }}
                >
                  <Form.Item
                    label="Client id"
                    name="Client id"
                    rules={[
                      {
                        required: true,
                        message: 'Please input Client id!',
                      },
                    ]}
                  >
                    <Input placeholder="bk0u2LsqTHSRt20Bpmckyw"/>
                  </Form.Item>

                  <Form.Item
                    label="Client secret"
                    name="Client secret"
                    rules={[
                      {
                        required: true,
                        message: 'Please input Client secret!',
                      },
                    ]}
                  >
                    <Input placeholder="BA5AIkug7wL8navO7GudoCs3Wqos7oEc" />
                  </Form.Item>

                  <Form.Item
                    wrapperCol={{
                      offset: 6,
                      span: 16,
                    }}
                  >
                    <button type="primary" htmlType="submit"
                     className='meeting_save_btn'
                    >
                      Save changes
                    </button>
                  </Form.Item>
                </Form>
            </div>

            <div className="zoomlive_right">
              <h4>How to create zoom meeting sdk?</h4>
              <div className=" zoom_live_instructions_div">
                <span className="zoom_insrtuction">
                  1. Login to{" "}
                  <a href="https://marketplace.zoom.us/">Zoom Marketplace</a>
                </span>
                <span className="zoom_insrtuction">
                  2. Go to the{" "}
                  <a href="https://marketplace.zoom.us/"> Build Legacy App</a>.
                  This page will appear displaying the available app types.
                </span>
                <span className="zoom_insrtuction">
                  3. Click Create in the Meeting SDK section.
                </span>
                <span className="zoom_insrtuction">
                  4. Add a name for your app and click Create.
                </span>
                <span className="zoom_insrtuction">
                  5. View your client ID and client secret. You'll use these
                  credentials to authenticate with Zoom.
                </span>
                <span className="zoom_insrtuction">
                  6. Add information about your app, such as a short description
                  and developer contact information (name and email address
                  required for activation).
                  <a href="https://developers.zoom.us/docs/internal-apps/create/">
                    More details
                  </a>
                </span>
              </div>
            </div>

        
        
        </div>
    </div>
  )
}

export default ZoomLive_Settings
